module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/DropDown.9a492bb3.svg";